import { StylesObjectType } from '../../../types/types';

export default function styles(): StylesObjectType {
  return {
    field: {
      width: '100%',
    },
  };
}
